export * from "/__w/wiggot-web/wiggot-web/packages/web-components/store/modals-portals/modal-allproperty.store.ts"